'use strict';
var contentSlots = {
    init: function () {
        (function(){
            if($('.global-insert-promo-slot').length > 0 ){   
            let flag = false;
            const stringTruncateUtil = (target,limitTitle,limitDesc) => {
                let strElePar = document.getElementsByClassName(target)[0],
                    strEleTitle = strElePar.getElementsByClassName('promoTitleText')[0],
                    strEleDesc  = strElePar.getElementsByClassName('promoDescTextInner')[0],
                    strEleTitleVal = strEleTitle.innerText,
                    strEleDescVal = strEleDesc.innerText,
                    truncatedstrEleTitleVal,
                    truncatedstrEleDescVal;
                    
                let i,
                    descDivs = document.querySelectorAll('.promoDescTextInner'),
                    titleDivs = document.querySelectorAll('.promoTitleText');
                    
                    if(strEleTitleVal.length > limitTitle) {
                        truncatedstrEleTitleVal = strEleTitleVal.substring(0,limitTitle);
                        if(truncatedstrEleTitleVal.indexOf('...') < 0) {
                            truncatedstrEleTitleVal = truncatedstrEleTitleVal + '...';
                        }
                        
                        for (i = 0; i < titleDivs.length; ++i) {
                            titleDivs[i].innerHTML = truncatedstrEleTitleVal;
                        }
                    }
                    
                    if(strEleDescVal.length > limitDesc) {
                        truncatedstrEleDescVal = strEleDescVal.substring(0,limitDesc);
                        if(truncatedstrEleDescVal.indexOf('...') < 0) {
                            truncatedstrEleDescVal = truncatedstrEleDescVal + '...';
                        }
                        
                        for (i = 0; i < descDivs.length; ++i) {
                            descDivs[i].innerHTML = truncatedstrEleDescVal;
                        }
                    }
                    flag = true;
                }            
                if(flag === false) {
                    stringTruncateUtil('global-insert-promo-slot', 53, 124);
                }
                $('.close-button').on('click', function(e){
                    e.stopPropagation();
                    e.preventDefault();
                    $(this).closest('.global-insert-promo-slot').remove();
                });
            }
        }());
    }
}
export default contentSlots;
